import { render, staticRenderFns } from "./DoKoSignin.vue?vue&type=template&id=37d12da6&scoped=true&"
import script from "./DoKoSignin.vue?vue&type=script&lang=ts&"
export * from "./DoKoSignin.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoSignin.vue?vue&type=style&index=0&id=37d12da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d12da6",
  null
  
)

export default component.exports